export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="relative h-12 w-12">
          <div className="absolute inset-0 rounded-full border-4 border-rose-100" />
          <div className="absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-rose-500" />
        </div>
        <p className="text-sm text-muted-foreground">불러오는 중…</p>
      </div>
    </div>
  );
}
